export default __webpack_public_path__ + "img/9557fc670da415f95b4a3ec667aa4dd9.png";